import React from 'react';

import { IconSize } from 'widget/shared/icons/BaseIcon';
import ErrorIcon from 'widget/shared/icons/ErrorIcon';

import styles from './ErrorReference.module.scss';

const ErrorReference: React.FC<{ tooltip?: string | null }> = ({ tooltip }) => (
  <div className={styles['error-reference']}>
    <ErrorIcon size={IconSize.M} className={styles['error-reference__icon']} />
    {tooltip && (
      <span className={styles['error-reference__tooltip']}>{tooltip}</span>
    )}
  </div>
);

export default React.memo(ErrorReference);
